import { render, staticRenderFns } from "./choice-test.vue?vue&type=template&id=89ea6854&scoped=true"
import script from "./choice-test.vue?vue&type=script&lang=js"
export * from "./choice-test.vue?vue&type=script&lang=js"
import style0 from "./choice-test.vue?vue&type=style&index=0&id=89ea6854&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ea6854",
  null
  
)

export default component.exports